export const INVALID_ELEMENT_ID_MESSAGE =
  "This mention has an invalid ElementId. Select the Revit element again.";

const CANONICAL_POSITIVE_DECIMAL = /^[1-9]\d*$/;
const CANONICAL_SIGNED_DECIMAL = /^(?:0|[1-9]\d*|-[1-9]\d*)$/;
const INT64_MAX = 9223372036854775807n;
const INT64_MIN = -9223372036854775808n;

export class InvalidElementIdError extends Error {
  readonly code = "INVALID_ELEMENT_ID";

  constructor() {
    super(INVALID_ELEMENT_ID_MESSAGE);
    this.name = "InvalidElementIdError";
  }
}

export function requireDocumentContextElementId(
  type: string,
  value: unknown,
): string {
  if (typeof value !== "string") {
    throw new InvalidElementIdError();
  }

  const isCategory = type.toLowerCase() === "category";
  const isCanonical = isCategory
    ? CANONICAL_SIGNED_DECIMAL.test(value)
    : CANONICAL_POSITIVE_DECIMAL.test(value);
  if (!isCanonical) throw new InvalidElementIdError();

  const parsed = BigInt(value);
  if (
    parsed > INT64_MAX ||
    (isCategory && (parsed < INT64_MIN || parsed === -1n))
  ) {
    throw new InvalidElementIdError();
  }
  return value;
}
